var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4941 51.9836L58.8454 54.7945C61.144 52.0791 62.951 48.9832 64.1851 45.6464L60.077 44.1523C59.0173 47.0094 57.4671 49.6595 55.4963 51.9836H55.4941Z",
    fill: "#FC6141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.875 60.8342L40.7784 65.1392C44.2734 64.5338 47.6353 63.3211 50.7119 61.5561L48.625 57.7695C45.9037 59.2809 42.9446 60.3173 39.875 60.8342Z",
    fill: "#FC6141"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.375 57.7695L20.1875 61.5561C23.2998 63.3219 26.6948 64.5342 30.2216 65.1392L30.9806 60.8364C27.9566 60.3184 25.0451 59.2808 22.375 57.7695Z",
    fill: "#FC6141"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9226 44.1523L6.81445 45.6464C8.04784 48.9831 9.85411 52.0789 12.152 54.7945L15.5032 51.9836C13.5324 49.6595 11.9823 47.0094 10.9226 44.1523Z",
    fill: "#FC6141"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 48.125C34.851 48.125 34.2166 48.3174 33.677 48.678C33.1374 49.0385 32.7169 49.551 32.4685 50.1506C32.2202 50.7501 32.1552 51.4099 32.2818 52.0464C32.4084 52.6829 32.7209 53.2676 33.1798 53.7264C33.6387 54.1853 34.2234 54.4978 34.8599 54.6245C35.4964 54.7511 36.1561 54.6861 36.7557 54.4377C37.3552 54.1894 37.8677 53.7688 38.2283 53.2292C38.5888 52.6896 38.7813 52.0552 38.7813 51.4062C38.7813 50.536 38.4355 49.7014 37.8202 49.0861C37.2048 48.4707 36.3702 48.125 35.5 48.125Z",
    fill: "#FC6141"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3125 17.5H37.6875V41.5625H33.3125V17.5Z",
    fill: "#FC6141"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.125 35H61.75C61.75 28.0381 58.9844 21.3613 54.0616 16.4384C49.1387 11.5156 42.4619 8.75 35.5 8.75C28.5381 8.75 21.8613 11.5156 16.9384 16.4384C12.0156 21.3613 9.25 28.0381 9.25 35H4.875C4.875 26.8777 8.10155 19.0882 13.8449 13.3449C19.5882 7.60155 27.3777 4.375 35.5 4.375C43.6223 4.375 51.4118 7.60155 57.1551 13.3449C62.8984 19.0882 66.125 26.8777 66.125 35Z",
    fill: "#FC6141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailIcon);
export default __webpack_public_path__ + "static/media/fail-icon.448166bcb1b5f46666bac9eedf89d0f8.svg";
export { ForwardRef as ReactComponent };